// export const LOGIN_USER = "/users/login";
export const LOGIN_USER = "/users/loginWithToken";
export const REGISTER_USER = "/users/register";
export const VERIFY_OTP = "/users/verify";
export const FORGOT_PASSWORD = "/users/forgotPassword";
export const CHANGE_PASSWORD = "/users/changePassword";
export const USER_SESSION = "/users/session";
export const USER_DETAILS = "/users/profile";
export const GET_WELCOME_BONUS = "/users/welcome/bonus";

export const SIGNUP_EMAIL = "/users/signup";
export const LOGIN_EMAIL = "/users/signin";

//Settings
export const GET_SETTINGS = "/settings/details";
export const GET_LANGUAGE = "/settings/language/json";
export const GET_LANGUAGE_LIST = "/settings/language/codes/name";
export const SYSTEM_ANNOUNCEMENT = "/settings/systemAnnouncement";
export const PAYMENT_STATUS = "/settings/paymentStatus";



// round multiplier
export const ROUND_MULTIPLIER = "/roundMultiplier/activeList";
export const SELECT_ROUNDMULTIPLIER_ROW = "/roundMultiplier/select";
export const REMOVE_ROUNDMULTIPLIER_ROW = "/roundMultiplier/selectedRemove";


// Friends
export const ADD_PARENT = "/users/add/parent";

export const GAME_START = "/games/start";
export const GAME_DETAILS = "/games/details/";
export const GAME_COMPLETE = "/games/complete/";
export const GAME_COMPLETE_BOMB = "/games/complete/bomb/";
export const GAME_STOP = "/games/stop/";
export const LEADERBOARD_UPDATE = "/games/leaderboard/";
export const GAME_UPDATE = "/games/update/";
export const GAME_HISTORY_LIST = "/games/history-list";
export const GAME_LEADERBOARD_LIST = "/leaderboard/list";
export const GET_CSRF_TOKEN = "/users/token";

export const USER_LOGOUT = "/users/logout";
export const PURCHASE_ENERGY = "/energy/purchase";
export const UPDATE_PROFILE = "/users/edit/";

//task
export const TASK_LIST = "/tasks/user/list";
export const TASK_COMPLETE = "/tasks/complete/";
export const TASK_STATUS = "/tasks/open/";
export const TASK_CLICKED = "/tasks/click/";
//claim
export const CLAIM_LIST = "/claim/list";
export const CLAIM_BALANCE = "/claim/transfer/";
export const GET_BTANICA_BALANCE = "/bitanica/btnc/balance";
export const TRANSFER_BTNC_FROM_BITANICA = "/bitanica/transfer/btnc";
export const UNCLAIMED_LIST = "/claim/available/list";
export const CLAIM_EXTERNAL = "/claim/external/";
export const CLAIM_BITANICA = "/claim/bitanica/";
export const GET_CONVERSION_PRICE = "/claim/convert/price";
export const BITANICA_HISTORY = "/claim/withdrawal/list";
export const EXTERNAL_HISTORY = "/claim/withdrawal/list";
//roadmaps
export const GET_ROADMAPS_LIST = "/roadmaps/list";
export const CHECK_BITANICA_LINKING = "/users/check/linking";

export const USER_BOT_LOGIN = "/users/login/mob";
export const USER_WEB_LOGIN = "/users/login/web";
export const GENERATE_TEL_LOGIN_QR = "/users/generate/qrcode";

export const USER_REFFERALS_LIST = "/referrals/list";
export const USER_EARNINGS_LIST = "/referrals/history";
export const CHECK_PROMOCODE = "/users/claim/promotion";

export const ENERGY_PACKAGES_LIST = "/energy/package/list";
export const ENERGY_PURCHASE_HISTORY = "/energy/purchase/history";
export const ENERGY_PURCHASE_HISTORY_DETAIL =
  "/energy/package/history/details/";
export const GET_PURCHASE_LINK = "/energy/package/purchase";
export const CHECK_PAYMENT_STATUS = "/energy/package/status";
export const CANCEL_PAYMENT = "/energy/package/cancel/";
export const PACKAGE_PURCHASE_HISTORY = "/energy/package/history";
export const GET_HOT_OFFER = "/energy/package/offer";
export const GET_CUSTOM_PURCHASE_LINK = "/energy/package/buy";

export const CREATE_PAYMENT_ORDER = "/energy/package/order";
export const CUSTOM_PAYWITH_BITANICA = "/energy/package/custom/bitanicaPay";
export const GET_PAYMENT_ORDER = "/energy/order/details";
export const GET_ORDER_LINK = "/energy/package/buyOrder";
export const PAY_WITH_BITANICA = "/energy/package/bitanicaPay";
export const CANCEL_BITANICA_PAY_ORDER = "/energy/cancelOrder/bitanicaPay";

export const JACKPOT_START = "/jackpot/start";
export const JACKPOT_COMPLETE = "/jackpot/complete/";
export const JACKPOT_HISTORY_LIST = "/jackpot/history/list";
export const JACKPOT_DETAILS = "/jackpot/details/";
export const JACKPOT_AMOUNT_DATA = "/jackpot/amounts";

export const USER_IP = "https://api.ipify.org?format=json";
